import React, {Component} from 'react'

import {Col} from "@amzn/stencil-react-components/layout"
import {Expander, ExpanderChevronPosition} from "@amzn/stencil-react-components/expander"

class Section extends Component {

  render() {
    const {title} = this.props;

    return (
      <Col margin={{top: 32}}>
        <Expander
          headingLevel={2}
          titleText={title}
          contentSpacing="S400"
          shouldExpandOnMount={this.props.shouldExpandOnMount}
          chevronPosition={ExpanderChevronPosition.Trailing}
        >
          <Col>
            {this.props.children}
          </Col>
        </Expander>
      </Col>
    )
  }
}

export default Section
